import { PoolDetails } from "@/models/pool-details.model";

const parseInitial = (initial: number): Date => {
  // "initial" est un entier qui contient un datecode tel qu'il est implémenté
  // dans le coffret. les 16 bits de poids faibles représentent le nombre de "10mins"
  // depuis le debut de l'année, Le poids fort le nombre d'années depuis 2000.

  const years = initial >> 16;
  const tenMins = initial & 0xffff;
  const now = new Date();
  const initialDate = new Date();
  initialDate.setTime((tenMins * 10 + now.getTimezoneOffset()) * 60 * 1000);
  initialDate.setFullYear(years + 2000);
  return initialDate;
};

export const deserializeAlert = (alert: PoolDetails["alerts"][number]) => {
  return {
    ...alert,
    initialDate: parseInitial(alert.initial),
  };
};
